<template>
  <div class="page-container has-action">
    <van-nav-bar title="确认订单" fixed left-arrow @click-left="goableBack()"></van-nav-bar>

    <van-cell
      class="cell-address"
      center
      isLink
      :to="{ name: 'address-choose', query: { choose: address.id } }"
      replace
    >
      <img slot="icon" class="left-icon mr-20" :src="require('@/assets/img/shop/icon-address.png')" />
      <div v-if="address.id">
        <div class="fs-16">
          {{ address.name }}
          <span class="fs-14 color-gray-dark">{{ address.phone }}</span>
        </div>
        <div class="fs-14">
          {{ address.provinceName }} {{ address.areaName }} {{ address.cityName }} {{
          address['address'] }}
        </div>
      </div>
      <div v-else>
        <div class="fs-16 py-10">请添选择收货地址</div>
      </div>
    </van-cell>

    <div class="mt-5 p-20 bg-color-white product">
      <div class="flex-row">
        <div class="left mr-20">
          <img :src="goods.coverImg" />
        </div>
        <div class="right">
          <div class="fs-16 mt-5">{{ goods.title }}</div>
          <div class="fs-12 mt-5 color-gray-dark">{{ goods.des }}</div>
          <div class="mt-10 flex-row flex-j-sb">
            <div class="fs-16">{{ goods.priceStr }} 积分</div>
            <div class="stepper">
              <van-stepper
                v-model="form.fields.num"
                :min="1"
                :max="sku.selectedSkuComb ? sku.selectedSkuComb.stock_num : 10"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20">兑换成功后将于7天内发货</div>
    </div>

    <div class="mt-5 bg-color-white" style="flex:1;">
      <van-cell title="商品积分" :value="`${total} 积分`"></van-cell>
      <van-cell title="运费" value=" 0 元"></van-cell>
      <div class="pl-20 py-20 color-gray-dark" style="display: flex;">
        <van-checkbox
          v-model="checked"
          checked-color="#FF7F00"
          icon-size="20px"
          style="margin-right: 5px;"
        ></van-checkbox>本人知晓并接受
        <!-- <router-link replace :to="{ name: 'agreement-shop' }" class="color-dark">商品兑换免责说明</router-link> -->
        <router-link :to="{ name: 'agreement-shop' }" class="color-dark">《商品兑换免责说明》</router-link>
      </div>
    </div>

    <div class="page-action flex-row flex-j-end flex-a-c px-20">
      <div class="color-red mr-20">消费积分: {{ total }} 分</div>
      <van-button class="py-10 px-30 btn-submit" round type="danger" @click="showPopup">兑换</van-button>
    </div>

    <!-- 弹出框 -->
    <van-popup closeable v-model="show" position="bottom" :style="{ height: '40%' }">
      <div class="texting">
        <div class="texting-box">
          <div class="texting-title">输入短信验证码</div>
          <div class="texting-number">短信发送至{{ userInfo.phone }}</div>

          <!-- 发送短信 start -->
          <van-field
            v-model="form.fields.code"
            center
            clearable
            placeholder="请输入短信验证码"
            type="number"
            style="border: 1px solid #d8d8d8;"
          >
            <!-- 发送 -->
            <template #button>
              <van-button
                @click="sendClick"
                size="small"
                :disabled="smsForm.disabled"
                :loading="smsForm.loading"
                loading-text="发送中..."
                style="background-color: #d8d8d8;"
              >{{ getSendBtnText }}</van-button>
            </template>
          </van-field>
          <!-- 发送短信 start -->
          <!-- 倒计时 -->

          <!-- 倒计时 -->
          <van-button class="confirm" @click="onSubmit" size="large">确认</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Stepper, Dialog, Toast, Popup, Checkbox, CheckboxGroup, Field } from 'vant';
import session from '@/utils/session';
import * as GoodsApi from '@/api/goods';
import * as CustApi from '@/api/cust';
import { mapGetters } from 'vuex'
export default {
  name: 'buy',
  data: () => ({
    // 提交订单-弹窗
    show: false,
    goods: {},
    sku: {},
    checked: false,
    address: false,
    // 新 始
    smsForm: {
      loading: false,
      smsCountDown: 0,
      smsInterval: null,
      disabled: false
    },
    // 终
    form: {
      fields: {
        num: '',
        addressId: '',
        skuId: '',
        code: ''
      }
    }
  }),
  beforeRouteEnter (to, from, next) {
    let sku = session.getJson('sku');
    if (!sku) {
      next({ name: 'home' });
      return;
    }
    let p1 = GoodsApi.getSku(sku.selectedSkuComb.id);
    let p2 = GoodsApi.getPlace(to.query.addressId);
    Promise.all([p1, p2])
      .then(data => {
        next(vm => {
          vm.setData({
            sku: sku,
            goods: data[0],
            address: data[1]
          });
        });
      })
      .then(e => {
      });
  },

  beforeRouteUpdate (to, from, next) {
    let sku = session.getJson('sku');
    if (!sku) {
      next({ name: 'home' });
      return;
    }
    let p1, p2;
    p1 = GoodsApi.getSku(sku.goodsId);
    p2 = GoodsApi.getPlace(to.query.addressId);
    Promise.all([p1, p2])
      .then(data => {
        this.setData({
          sku: sku,
          goods: data[0],
          address: data[1]
        });
        next();
      })
      .then(e => {
      });
  },
  beforeRouteLeave (to, from, next) {
    if (!['address-choose', 'shop-pay', 'agreement-shop', 'address-edit', 'shop-pay-success', 'description'].includes(to.name)) {
      Dialog.confirm({
        confirmButtonText: '去意已决',
        cancelButtonText: '我再想想',
        confirmButtonColor: 'black',
        message: '优惠不等人,真的要走吗?'
      })
        .then(() => {
          next();
        })
        .catch(() => {
          // on cancel
        });
    } else {
      next();
    }
  },

  watch: {
    'form.fields.num': function (val) {
      let sku = session.getJson('sku');
      sku.selectedNum = val;
      session.setJson('sku', sku);
    },
    $route (to, from) {
    }
  },
  computed: {
    total: function () {
      return (this.goods.price * 100 * this.form.fields.num) / 100;
    },
    getSendBtnText () {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown + "后重新发送";
      } else {
        return '获取验证码';
      }
    },
    ...mapGetters([
      'userInfo', 'channel'
    ]),
  },
  methods: {
    // 勾选
    // 发送验证码
    sendClick () {
      this.smsForm.loading = true;
      CustApi.withdrawcode()
        .then(data => {
          this.smsForm.loading = false;
          this.smsForm.disabled = true;
          this.startSMSTimer();
        })
        .catch(e => {
          this.smsForm.loading = false;
          Toast(e.msg || e.message);
        });
    },
    // 倒计时
    startSMSTimer () {
      this.smsForm.smsCountDown = 60;
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--;
        if (this.smsForm.smsCountDown <= 0) {
          this.smsForm.disabled = false;
          clearInterval(this.smsForm.smsInterval);
        }
      }, 1000);
    },
    // popup 弹出框
    showPopup () {

      if (!this.form.fields.addressId) {
        Dialog.confirm({
          confirmButtonText: '添加',
          message: '您还没有收货地址,请点击添加'
        })
          .then(() => {
            this.$router.replace({ name: 'address-edit', query: { redirect: 'shop-product-buy' } });
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      if (this.checked !== true) {
        Toast('请勾选服务协议');
        return;
      }
      if (this.total > this.userInfo.custAccount.score) {
        Toast('积分不足');
        return;
      }

      if (this.checked == true) {
        if (!this.form.fields.addressId) {
          Dialog.confirm({
            confirmButtonText: '添加',
            message: '您还没有收货地址,请点击添加'
          })
            .then(() => {
              this.$router.replace({ name: 'address-edit', query: { redirect: 'shop-product-buy' } });
            })
            .catch(() => {
              // on cancel
            });
          return;
        }
        this.show = true;
      } else {
        Toast('请勾选服务协议');
      }
    },
    setData (data) {
      // console.info(data.goods, data.sku);
      this.sku = data.sku;
      this.goods = data.goods;
      this.address = data.address || {};
      this.form.fields = {
        skuId: this.sku.selectedSkuComb.id,
        num: this.sku.selectedNum,
        addressId: this.address.id
      };
    },
    onSubmit () {
      GoodsApi.createOrder(this.form.fields)
        .then(data => {
          this.$router.replace({ name: 'shop-pay-success', params: { id: data } });
        })
        .catch(e => {
          Toast(e.msg);
        });
    }
  },
  components: {
    [Stepper.name]: Stepper,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Field.name]: Field
  }
};
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  box-sizing: border-box;
  min-height: 100%;
}

.cell-address {
  .left-icon {
    width: 30px;
    height: auto;
  }

  .van-cell__value {
  }

  &::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;

    background: repeating-linear-gradient(
      -45deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%
    );
    background-size: 80px;
    content: '';
  }
}

.product {
  .left {
    width: 85px;

    img {
      width: 100%;
      height: auto;
    }
  }

  .right {
    flex: 1;
  }
}

.btn-submit {
  height: auto;
  line-height: normal;
}

.texting {
  // border: 1px solid #000000;

  .texting-box {
    margin: 0 20px;
    text-align: center;

    .texting-title {
      font-size: 20px;
      font-weight: 700;
      margin-top: 15px;
      margin-bottom: 10px;
    }

    .texting-number {
      margin-bottom: 15px;
    }

    .fs {
      display: flex;

      .input {
        height: 40px;
        flex: 1;
        margin-left: 5px;
      }

      .transfer {
        width: 80px;
        height: 45px;
        margin-left: 10px;
        background-color: #d8d8d8;
      }
    }

    .confirm {
      background-color: #deb887;
      color: #ffffff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      margin-bottom: 56px;
    }
  }
}

.color-dark {
  color: #1989fa;
}
</style>
